import { START_LOADER, STOP_LOADER } from '../action.types'

import initialState from '../initial.state'
import SwitchCase from '../../shared/functions/SwitchCase'

export default (state = initialState.loading, action) =>
  SwitchCase({
    [START_LOADER]: action.loading,
    [STOP_LOADER]: action.loading
  })(state)(action.type)
